module.exports = __webpack_public_path__ + "img/logo.f9fc5aee.svg";